import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaHospital, FaArrowRight } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const staticUser = "Unityhospital";
  const staticPass = "Unityhospital@123";

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    // Simulate API call delay
    setTimeout(() => {
      const trimmedUsername = username.trim();
      const trimmedPassword = password.trim();

      if (!trimmedUsername || !trimmedPassword) {
        setError("Please fill in all fields");
        toast.error("Missing credentials!");
        setIsLoading(false);
        return;
      }

      if (trimmedUsername === staticUser && trimmedPassword === staticPass) {
        toast.success("Welcome to Unity Hospital");
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 1500);
      } else {
        setError("Invalid credentials! Please try again.");
        toast.error("Authentication Failed!");
      }
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Image */}
      <img 
        src="images/login.jpeg"
        alt="Hospital Background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/60 to-purple-900/40 z-0" />

      {/* Login Container */}
      <div className="backdrop-blur-lg bg-white/30 p-10 rounded-3xl shadow-2xl w-96 transform transition-all duration-500 hover:shadow-3xl relative z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-purple-600/20 backdrop-blur-sm" />
        
        <div className="relative z-10">
          <div className="text-center mb-8">
            <FaHospital className="text-white text-6xl mx-auto mb-4 animate-pulse" />
            <h1 className="text-4xl font-bold text-white mb-2 font-serif">
              Unity Ortho And Eye Hospital
            </h1>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="group relative">
              <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-200 group-hover:text-white transition-colors" />
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full pl-12 pr-4 py-3 bg-white/20 backdrop-blur-sm rounded-lg border-2 border-white/30 focus:border-white/50 focus:ring-0 placeholder:text-gray-200 text-white transition-all"
                disabled={isLoading}
                required
              />
            </div>

            <div className="group relative">
              <FaLock className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-200 group-hover:text-white transition-colors" />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-12 pr-4 py-3 bg-white/20 backdrop-blur-sm rounded-lg border-2 border-white/30 focus:border-white/50 focus:ring-0 placeholder:text-gray-200 text-white transition-all"
                disabled={isLoading}
                required
              />
            </div>

            {error && (
              <div className="mt-4 p-3 bg-red-100/80 border border-red-300 text-red-700 rounded-lg flex items-center backdrop-blur-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full flex items-center justify-center space-x-3 ${
                isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
              } text-white py-4 rounded-xl transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl`}
            >
              {isLoading ? (
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
              ) : (
                <>
                  <span>Login</span>
                  <FaArrowRight className="animate-bounce-horizontal" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <ToastContainer 
        position="top-center"
        autoClose={3000}
        theme="colored"
        toastStyle={{ backgroundColor: '#2563eb', color: 'white' }}
      />
    </div>
  );
};

export default Login;